/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseBannerBlockGroesse } from './DatabaseBannerBlockGroesse';
import {
    DatabaseBannerBlockGroesseFromJSON,
    DatabaseBannerBlockGroesseFromJSONTyped,
    DatabaseBannerBlockGroesseToJSON,
} from './DatabaseBannerBlockGroesse';
import type { DatabaseBannerHoehe } from './DatabaseBannerHoehe';
import {
    DatabaseBannerHoeheFromJSON,
    DatabaseBannerHoeheFromJSONTyped,
    DatabaseBannerHoeheToJSON,
} from './DatabaseBannerHoehe';
import type { DatabaseBannerKarten } from './DatabaseBannerKarten';
import {
    DatabaseBannerKartenFromJSON,
    DatabaseBannerKartenFromJSONTyped,
    DatabaseBannerKartenToJSON,
} from './DatabaseBannerKarten';
import type { DatabaseBannerStile } from './DatabaseBannerStile';
import {
    DatabaseBannerStileFromJSON,
    DatabaseBannerStileFromJSONTyped,
    DatabaseBannerStileToJSON,
} from './DatabaseBannerStile';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseKlappzeile } from './DatabaseKlappzeile';
import {
    DatabaseKlappzeileFromJSON,
    DatabaseKlappzeileFromJSONTyped,
    DatabaseKlappzeileToJSON,
} from './DatabaseKlappzeile';
import type { DatabasePageBlock } from './DatabasePageBlock';
import {
    DatabasePageBlockFromJSON,
    DatabasePageBlockFromJSONTyped,
    DatabasePageBlockToJSON,
} from './DatabasePageBlock';
import type { DatabasePageBlockActionType } from './DatabasePageBlockActionType';
import {
    DatabasePageBlockActionTypeFromJSON,
    DatabasePageBlockActionTypeFromJSONTyped,
    DatabasePageBlockActionTypeToJSON,
} from './DatabasePageBlockActionType';
import type { DatabaseSubDbListDisplay } from './DatabaseSubDbListDisplay';
import {
    DatabaseSubDbListDisplayFromJSON,
    DatabaseSubDbListDisplayFromJSONTyped,
    DatabaseSubDbListDisplayToJSON,
} from './DatabaseSubDbListDisplay';
import type { DatabaseSubDbListLayout } from './DatabaseSubDbListLayout';
import {
    DatabaseSubDbListLayoutFromJSON,
    DatabaseSubDbListLayoutFromJSONTyped,
    DatabaseSubDbListLayoutToJSON,
} from './DatabaseSubDbListLayout';
import type { DatabaseSubDbListSource } from './DatabaseSubDbListSource';
import {
    DatabaseSubDbListSourceFromJSON,
    DatabaseSubDbListSourceFromJSONTyped,
    DatabaseSubDbListSourceToJSON,
} from './DatabaseSubDbListSource';

/**
 * BAUSTEIN „LISTE AUS UNTERDATENBANK" (Betreiber 11.09.2026).
 * 
 * Ein Baustein, der seinen Inhalt nicht fest verdrahtet hat, sondern aus
 * den Datensaetzen einer Unterdatenbank holt. Er traegt im Prototyp der
 * Minigolf-Scorecard fuenf verschiedene Stellen — Aktionsflaeche,
 * Werbung je Bahn, Bahn-Tipps, Rangliste und Siegertreppchen — und ist
 * bewusst so geschnitten, dass er nicht nach Minigolf riecht:
 * „Zeige Eintraege aus einer Liste, passend zum Zusammenhang, mit einem
 * Rueckfall" ist kein Minigolf-Problem.
 * 
 * FELDROLLEN STATT FESTER FELDER: Der Baustein weiss nicht, wie die
 * Felder der Quelle heissen. Er kennt sechs Rollen — Abzeichen, Titel,
 * Text, Preis, Bild, Popup-Text — und der Betreiber ordnet ihnen Felder
 * zu. Derselbe Baustein traegt damit eine Sponsorenleiste und eine
 * Rangliste.
 * @export
 * @interface DatabaseSubDbListPageBlock
 */
export interface DatabaseSubDbListPageBlock extends DatabasePageBlock {
    /**
     * Unterdatenbank, deren Datensaetze angezeigt werden.
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    childDatabaseId?: string;
    /**
     * 
     * @type {DatabaseSubDbListSource}
     * @memberof DatabaseSubDbListPageBlock
     */
    source?: DatabaseSubDbListSource;
    /**
     * Nur bei `source: FIXED` — der Hauptdatensatz, dessen
     * Unterdatensaetze gezeigt werden.
     * 
     * WOFUER: Bahnen und Anzeigen einer Minigolfanlage gehoeren der
     * ANLAGE, nicht der einzelnen Runde. Ohne diese Wahl stuende
     * jede neue Spielgruppe vor leeren Bahnen. Dasselbe gilt fuer
     * Sponsoren einer Zeitung oder Hinweise eines Fragebogens.
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    fixedEntryId?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseSubDbListPageBlock
     */
    fontSize?: DatabaseFontSizeEnum;
    /**
     * Was dasteht, wenn die Liste LEER ist. Ohne Angabe steht dort
     * nichts — so wie bisher, damit bestehende Vorlagen sich nicht
     * von selbst aendern.
     * 
     * WOFUER: Eine leere Liste ist sonst ein stummes Loch. Auf der
     * Minigolf-Karte blieb unter „Schlaege auf dieser Bahn" eine
     * halbe Seite leer, solange keine Mitspieler eingetragen waren
     * — ohne ein Wort, was zu tun ist. Der Satz gehoert dem
     * Betreiber, nicht dem Programm: Nur er weiss, warum seine
     * Liste leer sein kann.
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    emptyText?: string;
    /**
     * 
     * @type {DatabaseSubDbListDisplay}
     * @memberof DatabaseSubDbListPageBlock
     */
    display?: DatabaseSubDbListDisplay;
    /**
     * 
     * @type {DatabaseSubDbListLayout}
     * @memberof DatabaseSubDbListPageBlock
     */
    layout?: DatabaseSubDbListLayout;
    /**
     * 
     * @type {DatabaseBannerHoehe}
     * @memberof DatabaseSubDbListPageBlock
     */
    hoehenModus?: DatabaseBannerHoehe;
    /**
     * 
     * @type {DatabaseBannerBlockGroesse}
     * @memberof DatabaseSubDbListPageBlock
     */
    blockGroesse?: DatabaseBannerBlockGroesse;
    /**
     * 
     * @type {DatabaseBannerStile}
     * @memberof DatabaseSubDbListPageBlock
     */
    bannerStile?: DatabaseBannerStile;
    /**
     * DIE ANORDNUNG JE DATENSATZ.
     * 
     * Bis hierher sass die Anordnung am BAUSTEIN — alle Eintraege
     * einer rotierenden Reihe sahen damit gleich aus. Die
     * Spezifikation der Scorecard verlangt aber sechs verschiedene
     * Banner im Wechsel: Preis-Kachel, Emoji-Zeile, Gruppen-Angebot,
     * Foto rechts, rundes Foto links, Abend-Veranstaltung.
     * 
     * Steht hier ein Feld, liest der Baustein die Anordnung JE
     * EINTRAG daraus. Der Wert muss einer der Namen aus
     * `DatabaseSubDbListLayout` sein; was nicht passt, faellt auf
     * `layout` zurueck. Ohne Angabe bleibt alles wie bisher.
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    layoutFieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    badgeFieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    titleFieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    textFieldId?: string;
    /**
     * ZIELGRUPPE — die Zeile „FUER GRUPPEN & FAMILIEN" ueber der
     * Ueberschrift. Nur GRUPPEN_STACK zeigt sie.
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    zielgruppeFieldId?: string;
    /**
     * LABEL — die kleine Metazeile in Grossbuchstaben („SPAR-KOMBI",
     * „FR & SA AB 20:00 UHR"). GRUPPEN_STACK und EVENT_CARD.
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    labelFieldId?: string;
    /**
     * ICON — ein Zeichen oder Emoji links im Band. Nur ICON_EXPRESS.
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    iconFieldId?: string;
    /**
     * BUTTON — die Handlungsflaeche rechts („5,00 € ›", „Tickets ›",
     * „-10% Rabatt"). Sie ersetzt die frueher getrennte Rolle
     * „Preis": In der Vorlage des Betreibers ist der Preis genau
     * dieser Knopf.
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    buttonFieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    priceFieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    imageFieldId?: string;
    /**
     * Feld mit dem Text, den ein Antippen als Popup zeigt.
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    popupFieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    linkFieldId?: string;
    /**
     * Das Feld, dessen im Editor gestalteter Inhalt die Art
     * `FREIE_GESTALTUNG` ueber die ganze Flaeche zeigt.
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    gestaltungFieldId?: string;
    /**
     * 
     * @type {DatabaseBannerKarten}
     * @memberof DatabaseSubDbListPageBlock
     */
    kartenAuswahl?: DatabaseBannerKarten;
    /**
     * NUR BEI `kartenAuswahl: AUSWAHL` — die NAMEN der Karten, auf
     * denen das Band erscheint („bei Auswahl Dropdown mit
     * Mehrfachauswahl", Betreiber 13.09.2026).
     * 
     * DER NAME, NICHT DIE KENNUNG: Eine Karte kann kopiert oder neu
     * angelegt werden; ihr Name ist das, was der Betreiber in der
     * Maske sieht und auswaehlt. Dieselbe Wahl wie beim
     * Anzeigefilter ueber den Seitennamen.
     * @type {Array<string>}
     * @memberof DatabaseSubDbListPageBlock
     */
    karten?: Array<string>;
    /**
     * Feld der QUELLE, nach dem gefiltert wird.
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    filterFieldId?: string;
    /**
     * Fester Vergleichswert. Leer = kein fester Wert.
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    filterValue?: string;
    /**
     * Feld des GEOEFFNETEN Datensatzes, dessen Wert verglichen wird —
     * die Alternative zum festen Wert. Damit zeigt „Werbung zur
     * aktuellen Bahn" ohne Zutun die richtige Anzeige: `filterFieldId`
     * = „Gilt fuer" in der Quelle, `filterByFieldId` = „Aktuelle
     * Bahn" im Datensatz.
     * 
     * Ein LEERER Wert in der Quelle gilt immer (= „ueberall"), sonst
     * muesste der Betreiber jede Anzeige fuer jede Bahn anlegen.
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    filterByFieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    sortFieldId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseSubDbListPageBlock
     */
    sortDescending?: boolean;
    /**
     * Hoechstens so viele Datensaetze. Leer = alle.
     * @type {number}
     * @memberof DatabaseSubDbListPageBlock
     */
    maxItems?: number;
    /**
     * Nur bei `display: BANNER` — Takt, in dem weitergeblaettert
     * wird. 0 oder leer = keine Rotation.
     * @type {number}
     * @memberof DatabaseSubDbListPageBlock
     */
    rotationSeconds?: number;
    /**
     * Datensatz, der einspringt, wenn der Filter nichts findet. Ohne
     * ihn bliebe an der Stelle ein Loch — im Prototyp ausdruecklich
     * unerwuenscht („nie ein leerer Platz").
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    fallbackEntryId?: string;
    /**
     * Platzziffer vor jeder Zeile (Rangliste, Treppchen).
     * @type {boolean}
     * @memberof DatabaseSubDbListPageBlock
     */
    showRank?: boolean;
    /**
     * NUR BEI `display: TREPPCHEN_RANGLISTE` — die Farbe der Balken
     * AB PLATZ 4. Die ersten drei stehen in Gold, Silber und Bronze.
     * 
     * WARUM EINE EIGENE ANGABE: Die „Hintergrundfarbe" des Bausteins
     * faerbt bei einem vollflaechigen Baustein die GANZE Flaeche —
     * mit ihr wuerde der Kasten hinter den Balken mitgefaerbt.
     * 
     * Ohne Angabe gilt die Farbe des Farbschemas der Datenbank; hat
     * die keine, bleiben die Balken durchsichtig (keine erfundene
     * Farbe — Vorgabe des Betreibers vom 14.09.2026).
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    balkenFarbe?: string;
    /**
     * ZAEHLER IN DER LISTE. Felder der Quelle, die in der Liste
     * BEARBEITET werden duerfen — in der Reihenfolge, in der sie
     * durchgezaehlt werden.
     * 
     * Bei einer Scorecard sind das die 18 (oder 36) Bahn-Felder des
     * Spielers; gezeigt wird immer nur eines, naemlich das zur
     * aktuellen Bahn. Dieselbe Bauart traegt „Ist je Monat" neben
     * „Plan je Monat" oder eine Menge je Kalenderwoche.
     * 
     * Genau EIN Feld in der Liste heisst: immer dieses. Mehrere
     * Felder brauchen `inputIndexFieldId`.
     * @type {Array<string>}
     * @memberof DatabaseSubDbListPageBlock
     */
    inputFieldIds?: Array<string>;
    /**
     * HOECHSTENS SO VIELE. Ist die Zahl erreicht, verschwindet der
     * Knopf zum Anlegen.
     * 
     * WOFUER: „1 bis maximal 6 Spieler" ist eine Regel des Betriebs,
     * nicht eine des Gastes — sechs Zaehler passen auf den
     * Bildschirm, sieben nicht mehr. Ohne Angabe (oder 0) gibt es
     * keine Obergrenze; damit bleibt jede bestehende Vorlage
     * unveraendert.
     * @type {number}
     * @memberof DatabaseSubDbListPageBlock
     */
    maxCreate?: number;
    /**
     * EIN KNOPF, DER EINEN DATENSATZ ANLEGT.
     * 
     * Der Baustein zeigte bisher nur an. „Bis zu sechs Mitspieler
     * eintragen" — die zentrale Handlung einer Setup-Seite — war
     * damit nicht baubar.
     * 
     * Angelegt wird ein Unterdatensatz am geoeffneten Datensatz.
     * Arbeitet der Gast noch auf einem ENTWURF (die Broschuere legt
     * anonymen Besuchern einen an, der noch keine Kennung hat), wird
     * dieser zuerst gespeichert — sonst gaebe es nichts, woran der
     * neue Datensatz haengen koennte.
     * @type {boolean}
     * @memberof DatabaseSubDbListPageBlock
     */
    allowCreate?: boolean;
    /**
     * Beschriftung des Knopfes. Ohne Angabe „Hinzufuegen".
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    createLabel?: string;
    /**
     * Feld, nach dem beim Anlegen gefragt wird — beim Bahnengolf der
     * Name des Mitspielers. Ohne Angabe gilt das Feld der Rolle
     * „Titel"; ist auch das leer, entsteht ein leerer Datensatz.
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    createValueFieldId?: string;
    /**
     * EIN KREUZ ZUM LOESCHEN an jeder Zeile.
     * 
     * WOFUER: Wer Mitspieler eintragen kann, vertippt sich auch —
     * „Spieler 1 … ×" steht so im Prototyp der Scorecard. Ohne den
     * Schalter bleibt die Liste reine Anzeige; bestehende Vorlagen
     * aendern sich nicht.
     * 
     * Gefragt wird vor dem Loeschen: Ein Datensatz mit den Schlaegen
     * einer halben Runde darf nicht auf einen Fehlgriff hin
     * verschwinden.
     * @type {boolean}
     * @memberof DatabaseSubDbListPageBlock
     */
    allowDelete?: boolean;
    /**
     * DEN NAMEN IN DER ZEILE AENDERN. Das Feld der Rolle
     * „Ueberschrift" wird zum Eingabefeld und beim Verlassen
     * gespeichert.
     * 
     * WOFUER: Im Prototyp sind die Spielernamen Eingabezeilen, keine
     * Beschriftungen — man tippt sie dort ein, wo sie stehen. Ohne
     * den Schalter bleibt die Ueberschrift Text.
     * @type {boolean}
     * @memberof DatabaseSubDbListPageBlock
     */
    titleEditable?: boolean;
    /**
     * Feld des GEOEFFNETEN Datensatzes, dessen Wert sagt, welches der
     * `inputFieldIds` gerade bearbeitet wird — 1 fuer das erste.
     * 
     * BEWUSST EINE ZIFFER UND KEIN NAME: Ein Feld ueber seinen Namen
     * zu suchen („Bahn " + Nummer) haengt das Verhalten an einen
     * Textinhalt. Wer das Feld umbenennt, bricht die Karte, ohne dass
     * irgendwo etwas davon steht.
     * @type {string}
     * @memberof DatabaseSubDbListPageBlock
     */
    inputIndexFieldId?: string;
}

/**
 * Check if a given object implements the DatabaseSubDbListPageBlock interface.
 */
export function instanceOfDatabaseSubDbListPageBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseSubDbListPageBlockFromJSON(json: any): DatabaseSubDbListPageBlock {
    return DatabaseSubDbListPageBlockFromJSONTyped(json, false);
}

export function DatabaseSubDbListPageBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseSubDbListPageBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabasePageBlockFromJSONTyped(json, ignoreDiscriminator),
        'childDatabaseId': !exists(json, 'childDatabaseId') ? undefined : json['childDatabaseId'],
        'source': !exists(json, 'source') ? undefined : DatabaseSubDbListSourceFromJSON(json['source']),
        'fixedEntryId': !exists(json, 'fixedEntryId') ? undefined : json['fixedEntryId'],
        'fontSize': !exists(json, 'fontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['fontSize']),
        'emptyText': !exists(json, 'emptyText') ? undefined : json['emptyText'],
        'display': !exists(json, 'display') ? undefined : DatabaseSubDbListDisplayFromJSON(json['display']),
        'layout': !exists(json, 'layout') ? undefined : DatabaseSubDbListLayoutFromJSON(json['layout']),
        'hoehenModus': !exists(json, 'hoehenModus') ? undefined : DatabaseBannerHoeheFromJSON(json['hoehenModus']),
        'blockGroesse': !exists(json, 'blockGroesse') ? undefined : DatabaseBannerBlockGroesseFromJSON(json['blockGroesse']),
        'bannerStile': !exists(json, 'bannerStile') ? undefined : DatabaseBannerStileFromJSON(json['bannerStile']),
        'layoutFieldId': !exists(json, 'layoutFieldId') ? undefined : json['layoutFieldId'],
        'badgeFieldId': !exists(json, 'badgeFieldId') ? undefined : json['badgeFieldId'],
        'titleFieldId': !exists(json, 'titleFieldId') ? undefined : json['titleFieldId'],
        'textFieldId': !exists(json, 'textFieldId') ? undefined : json['textFieldId'],
        'zielgruppeFieldId': !exists(json, 'zielgruppeFieldId') ? undefined : json['zielgruppeFieldId'],
        'labelFieldId': !exists(json, 'labelFieldId') ? undefined : json['labelFieldId'],
        'iconFieldId': !exists(json, 'iconFieldId') ? undefined : json['iconFieldId'],
        'buttonFieldId': !exists(json, 'buttonFieldId') ? undefined : json['buttonFieldId'],
        'priceFieldId': !exists(json, 'priceFieldId') ? undefined : json['priceFieldId'],
        'imageFieldId': !exists(json, 'imageFieldId') ? undefined : json['imageFieldId'],
        'popupFieldId': !exists(json, 'popupFieldId') ? undefined : json['popupFieldId'],
        'linkFieldId': !exists(json, 'linkFieldId') ? undefined : json['linkFieldId'],
        'gestaltungFieldId': !exists(json, 'gestaltungFieldId') ? undefined : json['gestaltungFieldId'],
        'kartenAuswahl': !exists(json, 'kartenAuswahl') ? undefined : DatabaseBannerKartenFromJSON(json['kartenAuswahl']),
        'karten': !exists(json, 'karten') ? undefined : json['karten'],
        'filterFieldId': !exists(json, 'filterFieldId') ? undefined : json['filterFieldId'],
        'filterValue': !exists(json, 'filterValue') ? undefined : json['filterValue'],
        'filterByFieldId': !exists(json, 'filterByFieldId') ? undefined : json['filterByFieldId'],
        'sortFieldId': !exists(json, 'sortFieldId') ? undefined : json['sortFieldId'],
        'sortDescending': !exists(json, 'sortDescending') ? undefined : json['sortDescending'],
        'maxItems': !exists(json, 'maxItems') ? undefined : json['maxItems'],
        'rotationSeconds': !exists(json, 'rotationSeconds') ? undefined : json['rotationSeconds'],
        'fallbackEntryId': !exists(json, 'fallbackEntryId') ? undefined : json['fallbackEntryId'],
        'showRank': !exists(json, 'showRank') ? undefined : json['showRank'],
        'balkenFarbe': !exists(json, 'balkenFarbe') ? undefined : json['balkenFarbe'],
        'inputFieldIds': !exists(json, 'inputFieldIds') ? undefined : json['inputFieldIds'],
        'maxCreate': !exists(json, 'maxCreate') ? undefined : json['maxCreate'],
        'allowCreate': !exists(json, 'allowCreate') ? undefined : json['allowCreate'],
        'createLabel': !exists(json, 'createLabel') ? undefined : json['createLabel'],
        'createValueFieldId': !exists(json, 'createValueFieldId') ? undefined : json['createValueFieldId'],
        'allowDelete': !exists(json, 'allowDelete') ? undefined : json['allowDelete'],
        'titleEditable': !exists(json, 'titleEditable') ? undefined : json['titleEditable'],
        'inputIndexFieldId': !exists(json, 'inputIndexFieldId') ? undefined : json['inputIndexFieldId'],
    };
}

export function DatabaseSubDbListPageBlockToJSON(value?: DatabaseSubDbListPageBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabasePageBlockToJSON(value),
        'childDatabaseId': value.childDatabaseId,
        'source': DatabaseSubDbListSourceToJSON(value.source),
        'fixedEntryId': value.fixedEntryId,
        'fontSize': DatabaseFontSizeEnumToJSON(value.fontSize),
        'emptyText': value.emptyText,
        'display': DatabaseSubDbListDisplayToJSON(value.display),
        'layout': DatabaseSubDbListLayoutToJSON(value.layout),
        'hoehenModus': DatabaseBannerHoeheToJSON(value.hoehenModus),
        'blockGroesse': DatabaseBannerBlockGroesseToJSON(value.blockGroesse),
        'bannerStile': DatabaseBannerStileToJSON(value.bannerStile),
        'layoutFieldId': value.layoutFieldId,
        'badgeFieldId': value.badgeFieldId,
        'titleFieldId': value.titleFieldId,
        'textFieldId': value.textFieldId,
        'zielgruppeFieldId': value.zielgruppeFieldId,
        'labelFieldId': value.labelFieldId,
        'iconFieldId': value.iconFieldId,
        'buttonFieldId': value.buttonFieldId,
        'priceFieldId': value.priceFieldId,
        'imageFieldId': value.imageFieldId,
        'popupFieldId': value.popupFieldId,
        'linkFieldId': value.linkFieldId,
        'gestaltungFieldId': value.gestaltungFieldId,
        'kartenAuswahl': DatabaseBannerKartenToJSON(value.kartenAuswahl),
        'karten': value.karten,
        'filterFieldId': value.filterFieldId,
        'filterValue': value.filterValue,
        'filterByFieldId': value.filterByFieldId,
        'sortFieldId': value.sortFieldId,
        'sortDescending': value.sortDescending,
        'maxItems': value.maxItems,
        'rotationSeconds': value.rotationSeconds,
        'fallbackEntryId': value.fallbackEntryId,
        'showRank': value.showRank,
        'balkenFarbe': value.balkenFarbe,
        'inputFieldIds': value.inputFieldIds,
        'maxCreate': value.maxCreate,
        'allowCreate': value.allowCreate,
        'createLabel': value.createLabel,
        'createValueFieldId': value.createValueFieldId,
        'allowDelete': value.allowDelete,
        'titleEditable': value.titleEditable,
        'inputIndexFieldId': value.inputIndexFieldId,
    };
}

